export default __webpack_public_path__ + "97a1da7b30c41dcaff1f1fa776e26c96.svg";